import { useAuthPost } from "../hooks/useAxios";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Button, Card } from './primitives/';
import { catchErrorParse } from '../ErrorUtility';

export default function MobileRegistrationComponent() {
    const { post } = useAuthPost();
    const { url } = useAuth();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    async function handleRegister() {
        try {
            const [result, error, errorCode, errorMessage] = await catchErrorParse(post, `${url}/webapp/register-mobile-workspace`);
            if (error) {
                window.dispatchEvent(new CustomEvent('masterError', {
                    detail: {
                        code: errorCode,
                        message: errorMessage ? errorMessage : error.message
                    }
                }));
                return;
            }
            if (result) {
                setIsLoading(false);
            }
        } catch (err) {
            setIsLoading(false);
            window.dispatchEvent(new CustomEvent('masterError', {
                detail: {
                    message: 'An unexpected error occurred during registration'
                }
            }));
        }
    }

    const handleNavigate = () => {
        navigate('/auth/dashboard');
    };

    useEffect(() => {
        handleRegister();
    }, []);

    return (
        <Card>
            <Card.Body>
                <h1>Mobile Registration</h1>
                <p>
                    You're all set!
                    <br />
                    <br />
                    Just download the app and you're good to go!
                    <Button 
                        onClick={handleNavigate}
                        loading={isLoading}
                    >
                        Return to Dashboard
                    </Button>
                </p>
            </Card.Body>
        </Card>
    );
}
